/**
 *    Map detail
 */

(function ($) {
  Drupal.behaviors.mapDetail = {
    attach(context, settings) {
      document.addEventListener('google-maps:loaded', () => {
        Drupal.behaviors.mapDetail.loadMap();
      });
    },

    loadMap(context, settings) {
      const basePath = drupalSettings.path.baseUrl;
      const $mapContainer = $('.vb-map-detail');

      if (!$mapContainer.length) {
        return false;
      }

      const $mapContent = $mapContainer.find('.vb-map-detail__content');
      const lat = $mapContainer.data('lat');
      const lng = $mapContainer.data('lng');
      const title = $mapContainer.data('address');

      if (!lat || !lng) {
        return false;
      }

      const location = { lat, lng };

      const map = new google.maps.Map($mapContent[0], {
        zoom: 12,
        center: location,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        rotateControl: false,
        scaleControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER,
        },
      });

      const marker = new google.maps.Marker({
        position: location,
        map,
        icon: {
          url: `${basePath}themes/custom/vb2016/components/meeting-guide/map/assets/markers/marker--pin.svg`,
          scaledSize: new google.maps.Size(50, 50),
          anchor: new google.maps.Point(25, 50),
        },
        clickable: false,
        title,
      });

      const bounds = new google.maps.LatLngBounds();

      // include map distances
      Drupal.behaviors.mapDistances.calculate(map, lat, lng, bounds);
    },
  };
}(jQuery));
// end of map-detail.js
